import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { convertDataToArtboard } from '../../../utils/fetchUtils'
import BaseDesignCard from './BaseDesignCard'

import { DMPrimaryButton } from '@decormatters/dm-theme'
import { logEvent } from '../../../utils/firebase'
import { useRouter as useHistory } from 'next/router'
import { setLocationState } from '../../../redux/designerReducers/locationStateReducer'
import { getMembershipType } from '../../../utils/getMembershipType'

const MyRoomCard = ({ data, from, onDelete, ...props }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const profile = useSelector(state => state.profile.me)
  const membershipInfo = getMembershipType(profile)

  const handleUse = e => {
    e.stopPropagation()
    if (!data) return

    logEvent('create_design_click', {})

    logEvent('my_room_use', {
      content_type: 'my_room',
      content_id: data.objectId
    })

    dispatch(
      setLocationState({
        idea: convertDataToArtboard(data.objectId, data.cfImageUrl, []),
        type: 'myrooms',
        markers: [],
        from,
        designData: data
      })
    )

    history.push('/create/design/new')
  }

  const handleDelete = e => {
    e.stopPropagation()

    if (onDelete) onDelete(data)
    /*
    if(!data.objectId) return

    firebase.analytics().logEvent('my_room_delete' , {
      content_type: 'my_room',
      content_id: data.objectId
    })


    dispatch(deleteMyRoom([data.objectId])).then(() => {
      dispatch(fetchMyRooms())
    })
    */
  }

  const menuItems = [
    {
      title: 'Delete',
      onClick: handleDelete,
      highlight: true
    }
  ]

  return (
    <BaseDesignCard
      data={data}
      menuItems={menuItems}
      onUse={handleUse}
      lock={!membershipInfo.isMember}
      {...props}
    >
      <DMPrimaryButton>Create Design</DMPrimaryButton>
    </BaseDesignCard>
  )
}

export default MyRoomCard
